import { gql } from '@apollo/client';
import { ALL_MEDIUM_FIELDS } from './fragments';

export const fetchFrequencyManagementSettings = gql`
  ${ALL_MEDIUM_FIELDS}

  query fetchFrequencyManagementSettings {
    currentProject {
      id
      settings {
        frequencyManagement {
          Email {
            ...AllMediumFields
          }
          Push {
            ...AllMediumFields
          }
          SMS {
            ...AllMediumFields
          }
        }
      }
    }
  }
`;
